import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const ExpectedPeriod = ({
  data,
}: {
  data?: IReportData['estimatedHoldingPeriod'];
}) => {
  const maxRate = Math.max(data?.rate1, data?.rate2, data?.rate3);
  let periodText = '';
  if (maxRate === data?.rate1) {
    periodText = '단기';
  } else if (maxRate === data?.rate2) {
    periodText = '중기';
  } else if (maxRate === data?.rate3) {
    periodText = '장기';
  }
  return (
    <s.Div>
      <s.Title>⏳예상 보유 기간</s.Title>
      <s.TopDescription style={{ display: 'block' }}>
        과거 유사 물건 분석 결과,
        <br />
        <span style={{ color: '#008AFF' }}>
          매입 후 평균 {periodText}에 매각
        </span>
        이 이루어진 사례가 다수 확인됨.
      </s.TopDescription>
      <s.Table>
        <s.TableHeader>
          <s.Header>항목</s.Header>
          <s.Header>평균 매각 기간</s.Header>
        </s.TableHeader>
        <s.Row style={{ position: 'relative' }}>
          <RowLeft>
            <Month>3개월 이내</Month>단기
          </RowLeft>
          <RowRight>
            <Gp_Circle percent={data?.rate1} />
          </RowRight>
          <MostTag isMost={maxRate === data?.rate1} />
        </s.Row>
        <s.Row style={{ position: 'relative' }}>
          <RowLeft>
            <Month>3~6개월</Month>중기
          </RowLeft>
          <RowRight>
            <Gp_Circle percent={data?.rate2} />
          </RowRight>
          <MostTag isMost={maxRate === data?.rate2} />
        </s.Row>
        <s.Row style={{ position: 'relative' }}>
          <RowLeft>
            <Month>6개월 이상</Month>장기
          </RowLeft>
          <RowRight>
            <Gp_Circle percent={data?.rate3} />
          </RowRight>
          <MostTag isMost={maxRate === data?.rate3} />
        </s.Row>
      </s.Table>
    </s.Div>
  );

  function Gp_Circle({ percent }: { percent: number }) {
    return (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="31"
          cy="31"
          r="26"
          fill="none"
          stroke="#70737C"
          stroke-opacity="0.16"
          stroke-width="10"
        />
        <circle
          cx="31"
          cy="31"
          r="26"
          fill="none"
          stroke="#008AFF"
          stroke-width="10"
          stroke-dasharray={Math.PI * 2 * 26} // ≈ 163.36
          stroke-dashoffset={Math.PI * 2 * 26 * (100 - percent) * 0.01}
          transform="rotate(-90 31 31)"
        />
        <text
          x="31"
          y="33"
          style={{
            fontSize: '14px',
            fontWeight: '700',
            fontFamily: 'Spoqa Han Sans Neo',
            letterSpacing: '-2%',
            lineHeight: '145%',
          }}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#222222"
        >
          {percent}%
        </text>
      </svg>
    );
  }

  function MostTag({ isMost }: { isMost: boolean }) {
    return (
      <MostBasic style={{ display: isMost ? 'block' : 'none' }}>
        <MostBasicDiv>가장 일반적</MostBasicDiv>
        <svg
          width="4"
          height="10"
          viewBox="0 0 4 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ position: 'absolute', top: '6px', right: '-4px' }}
        >
          <path d="M4 5L0 9.5L-7.86805e-07 0.5L4 5Z" fill="#F45551" />
        </svg>
      </MostBasic>
    );
  }
};

export default ExpectedPeriod;

const RowLeft = styled.div`
  width: 50%;
  height: 94px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const RowRight = styled.div`
  width: 50%;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Month = styled.div`
  width: fit-content;
  padding: 4px 8px;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
  color: rgba(55, 56, 60, 0.61);
`;

const MostBasic = styled.div`
  position: absolute;
  top: 36.5px;
  right: calc(25% + 44px);
`;

const MostBasicDiv = styled.div`
  width: 65px;
  height: 21px;
  border-radius: 4px;
  gap: 10px;
  padding-top: 2px;
  padding-right: 4px;
  padding-bottom: 2px;
  padding-left: 4px;
  background: #f45551;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
  color: #ffffff;
  position: relative;

  ::before {
    content: '';
    position: absolute;
    top: 14px; /* 세로 위치 (텍스트 중앙쯤) */
    left: -6px; /* 말풍선 왼쪽 밖으로 나가도록 */

    width: 20px;
    height: 20px;

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #f45551; /* 말풍선 색상 */
  }
`;
